import { defineStore } from 'pinia';

const STORAGE_KEY = 'refCode';
const storage = sessionStorage;

export const useRefCodeStore = defineStore('refCode', {
  state: () => ({
    refCode: storage.getItem(STORAGE_KEY) || null,
  }),
  getters: {
    getRefCode: (state) => state.refCode,
  },
  actions: {
    setRefCode(code) {
      this.refCode = code;
      storage.setItem(STORAGE_KEY, code);
    },
    clearRefCode() {
      this.refCode = null;
      storage.removeItem(STORAGE_KEY);
    },
  },
});